/* =========================================================
   Section: Puddi Header — Mobile Drawer

   Toggles the mobile nav drawer via the "Menu" button. Desktop
   hides the button and drawer via CSS, so this script runs
   harmlessly there.

   Handles:
     • Click on menu button → toggle drawer
     • Escape key → close drawer, return focus to button
     • Click on drawer link → close (navigation happens naturally)
     • Click outside → close
     • aria state sync (aria-expanded on button, aria-hidden on drawer)
   ========================================================= */

(function () {
  'use strict';

  var btn = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-menu-drawer]');
  if (!btn || !drawer) return;

  function setOpen(open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function toggle() {
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  }

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    toggle();
  });

  /* Close on link click — navigation still fires naturally */
  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      setOpen(false);
    });
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
      btn.focus();
    }
  });

  /* Close on click outside */
  document.addEventListener('click', function (e) {
    if (btn.getAttribute('aria-expanded') !== 'true') return;
    if (drawer.contains(e.target) || btn.contains(e.target)) return;
    setOpen(false);
  });
})();